export default "__VITE_ASSET__CVCCYcyI__"